export const ETH_REWARDS_MANAGER_CONTRACT_ADDRESS = '0x5aa6B99A2B461bA8E97207740f0A689C5C39C3b0';
//# sourceMappingURL=constants.js.map